import {
  IEgdApiClient,
  AdapterCollection,
  AccountSettingsForm,
  DomainSettingsForm,
  RadioButtonStatesAdapter,
  CustomScheduleAdapter,
  settings,
  StringAdapter,
  SchemaFactory,
  IAuth
} from 'v2/modules/lib'

export interface IQuarantineNotificationFormArgs {
  egdApiClient: IEgdApiClient
  accountId: string
  domainId: number | null
  auth: IAuth
}

export const QuarantineNotificationForm = ({
  egdApiClient,
  accountId,
  domainId,
  auth
}: IQuarantineNotificationFormArgs) => {
  const schema = SchemaFactory.fromSettings([
    settings.enable_quarantine,
    settings.allow_temporary_passcode,
    settings.custom_inbound_schedule,
    settings.inbound_schedule,
    settings.allow_override
  ])

  const adapters = AdapterCollection()
  adapters.add(RadioButtonStatesAdapter(settings.enable_quarantine))
  adapters.add(RadioButtonStatesAdapter(settings.allow_temporary_passcode))
  adapters.add(CustomScheduleAdapter(settings.custom_inbound_schedule))
  adapters.add(StringAdapter(settings.inbound_schedule))
  adapters.add(RadioButtonStatesAdapter(settings.allow_override))

  if (domainId) {
    return {
      form: DomainSettingsForm({
        egdApiClient,
        accountId,
        domainId,
        adapters,
        auth
      }),
      schema
    }
  }
  return {
    form: AccountSettingsForm({
      egdApiClient,
      accountId,
      adapters,
      auth
    }),
    schema
  }
}

export type IQuarantineNotificationForm = ReturnType<typeof QuarantineNotificationForm>
